var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Error(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-16",
    cx: 250.56,
    cy: 365.12,
    rx: 240.31,
    ry: 124.36,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.08,45.13l-9.18,5.3c0-.41.08-.81.08-1.21V46.56c0-4.73-3.33-6.65-7.42-4.28a14.14,14.14,0,0,0-4.42,4.25c-.68-6-5.34-8.17-11-4.89C68,45.17,63,53.78,63,60.86v4A10.5,10.5,0,0,0,64,69.45l-7.63,4.4A9.09,9.09,0,0,0,52.23,81c0,2.62,1.84,3.68,4.11,2.37l49.74-28.71a9.11,9.11,0,0,0,4.11-7.13C110.19,44.89,108.35,43.82,106.08,45.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.24,65l-6.93,4a7.22,7.22,0,0,0,.06-.92v-2c0-3.57-2.5-5-5.6-3.23a10.78,10.78,0,0,0-3.33,3.21c-.51-4.49-4-6.16-8.31-3.69-4.63,2.67-8.38,9.16-8.38,14.51v3a8,8,0,0,0,.71,3.48l-5.75,3.32a6.86,6.86,0,0,0-3.11,5.38c0,2,1.39,2.78,3.11,1.79l37.53-21.67a6.86,6.86,0,0,0,3.11-5.38C153.35,64.83,152,64,150.24,65Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-16",
    cx: 398.11,
    cy: 403.67,
    rx: 49.29,
    ry: 28.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-16",
    d: "M79.49,431.39,35.75,406.13c-2.47-1.42-2.47-3.73,0-5.15L280.51,259.83a9.89,9.89,0,0,1,8.93,0l43.75,25.26c2.46,1.42,2.46,3.73,0,5.15L88.42,431.39A9.89,9.89,0,0,1,79.49,431.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-16",
    d: "M314.39,341.39,309,338.25c-12.35-7.13-31.85-7.48-43.46-.78L245.18,349.2a1.5,1.5,0,1,0,1.5,2.6L267,340.07c10.78-6.23,28.94-5.88,40.46.77l5.44,3.15c5.3,3.06,8.22,7,8.22,11.2s-2.92,8.14-8.22,11.2l-74.49,43c-11.53,6.66-30.28,6.65-41.81,0L174.9,396.88c-12.35-7.13-32.45-7.13-44.8,0L124.66,400c-6.53,3.77-10.13,8.79-10.13,14.12,0,4.92,3.12,9.43,8.79,12.7l19.42,11.22-8,4.71c-3.65,2.15-3.63,5.64,0,7.76L149.39,459a.66.66,0,0,1,0,1.25l-1.22.69c-.6.34-.6.9,0,1.25l1.89,1.09a2.37,2.37,0,0,0,2.17,0l6.62-3.8a2.44,2.44,0,0,1,2.17,0l12,7a2.41,2.41,0,0,0,2.16,0l1.9-1.1c.6-.34.6-.9,0-1.25l-12-7c-.6-.35-.6-.91,0-1.25l4.62-2.67a2.35,2.35,0,0,1,2.16,0l12.06,6.95a2.35,2.35,0,0,0,2.16,0L188,459a.66.66,0,0,0,0-1.25l-12-7a.66.66,0,0,1,0-1.25l6-3.44a.66.66,0,0,0,0-1.25l-1.9-1.09a2.37,2.37,0,0,0-2.17,0l-1.89,1.09a2.44,2.44,0,0,1-2.17,0l-18.53-10.7a6.54,6.54,0,0,0-5.95,0l-3.69,2.17a1.65,1.65,0,0,0-.46-.41l-20.31-11.72c-4.7-2.72-7.29-6.3-7.29-10.11,0-4.16,3.15-8.36,8.63-11.52l5.44-3.15c11.53-6.65,30.28-6.65,41.8,0L195.09,412c12.36,7.13,32.45,7.13,44.81,0l74.49-43c6.27-3.62,9.72-8.52,9.72-13.8S320.66,345,314.39,341.39Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.43,402.36c-.39-19.29,7.18-36.72,13.66-45.3s17.35-17,24.91-14.6c7,2.2,6.53,11.37-1.77,17.67S432.42,374.39,429,385l-8.38,19.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.43,402.36c-.39-19.29,7.18-36.72,13.66-45.3s17.35-17,24.91-14.6c7,2.2,6.53,11.37-1.77,17.67S432.42,374.39,429,385l-8.38,19.48Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.73,400.52a.48.48,0,0,0,.41-.4c1.8-10.68,5.38-23,11.46-32.72,6.54-10.44,16-16.85,21.54-19.06a.47.47,0,0,0,.26-.61.47.47,0,0,0-.62-.26c-5.63,2.26-15.37,8.91-22.07,19.63-6.11,9.76-9.69,22.13-11.5,32.87a.47.47,0,0,0,.39.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.4,406.55c.94-3.66,5.22-9.78,12.26-14.93,7.79-5.69,17.77-8.48,20-12.81,2.65-5.2-1.8-9.92-9.93-8.69s-23.36,12.95-26.49,34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.72,402.78a.47.47,0,0,0,.4-.32c6.25-19.09,20.49-26.12,27.15-27.17a.47.47,0,1,0-.15-.93c-7.36,1.16-21.52,8.32-27.9,27.8a.48.48,0,0,0,.3.6A.47.47,0,0,0,421.72,402.78Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plug--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.38,434.11a1.53,1.53,0,0,1-.75-.2l-20.31-11.73c-5.67-3.27-8.79-7.78-8.79-12.7,0-5.34,3.6-10.35,10.13-14.12l5.44-3.15c12.35-7.13,32.45-7.13,44.8,0l21.69,12.53c11.53,6.65,30.28,6.65,41.81,0l74.49-43c5.3-3.06,8.22-7,8.22-11.21s-2.92-8.14-8.22-11.2l-5.44-3.14c-11.53-6.65-29.68-7-40.46-.77l-20.31,11.72a1.5,1.5,0,0,1-1.5-2.6l20.31-11.72c11.61-6.71,31.11-6.36,43.46.77l5.44,3.15c6.27,3.61,9.72,8.51,9.72,13.79s-3.45,10.19-9.72,13.8l-74.49,43c-12.36,7.14-32.45,7.14-44.81,0L173.4,394.81c-11.52-6.65-30.27-6.65-41.8,0L126.16,398c-5.48,3.17-8.63,7.37-8.63,11.53,0,3.8,2.59,7.39,7.29,10.1l20.31,11.73a1.5,1.5,0,0,1-.75,2.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.76,437.36v1.73a9.59,9.59,0,0,0,4.33,7.5l16,9.22,16.24-9.38V432.36l-15.78-7.28a10.81,10.81,0,0,0-8.87.4l-7.59,4.38A9.58,9.58,0,0,0,131.76,437.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.55,425.08a10.81,10.81,0,0,0-8.87.4l-7.59,4.38c-2.39,1.38-2.29,3.44.21,4.6l15.77,7.28,16.26-9.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.54,438.35a4.78,4.78,0,0,0-2.16,3.75v11.58l3.7,2.13,16.24-9.38V432.36l-4.12-1.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.71,429.94a1.53,1.53,0,0,0-1.52.15l-16,9.23a4.78,4.78,0,0,0-2.17,3.75v13.76a1.51,1.51,0,0,0,.64,1.4l2,1.17a1.5,1.5,0,0,0,1.53-.15l16-9.22a4.8,4.8,0,0,0,2.16-3.75V432.51a1.54,1.54,0,0,0-.63-1.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.24,440.49l16-9.23c1.19-.69,2.16-.13,2.16,1.25v13.77a4.8,4.8,0,0,1-2.16,3.75l-16,9.22c-1.2.69-2.17.13-2.17-1.25V444.24A4.78,4.78,0,0,1,154.24,440.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.79,450.89l-13.22-7.63-1.43.83v9.38l13.21,7.63a2.14,2.14,0,0,0,2.15.2l1.44-.83a2.1,2.1,0,0,0,.88-2v-2.38A6.69,6.69,0,0,0,170.79,450.89Zm-2.43,2.51a4.47,4.47,0,0,1,2,3.51,2.38,2.38,0,0,1-.07.56,2.46,2.46,0,0,1-.52-.21,4.51,4.51,0,0,1-2-3.52,2.47,2.47,0,0,1,.07-.57A2.13,2.13,0,0,1,168.36,453.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.79,450.89l-13.22-7.63-1.43.83,13.21,7.63a6.69,6.69,0,0,1,3,5.25v2.38a2.09,2.09,0,0,1-.95,2l.07,0,1.44-.84a2.09,2.09,0,0,0,.88-2v-2.38A6.72,6.72,0,0,0,170.79,450.89Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,456.14v2.38a2.09,2.09,0,0,1-.88,2l-1.44.84-.06,0a2.09,2.09,0,0,0,.94-2V457a6.21,6.21,0,0,0-.89-3l1.44-.83A6.18,6.18,0,0,1,173.82,456.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,456.14v2.38a2.09,2.09,0,0,1-.88,2l-1.44.84-.06,0a2.09,2.09,0,0,0,.94-2V457a6.21,6.21,0,0,0-.89-3l1.44-.83A6.18,6.18,0,0,1,173.82,456.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,456.14v2.38a2.09,2.09,0,0,1-.88,2l-1.44.84-.06,0a2.09,2.09,0,0,0,.94-2V457a6.21,6.21,0,0,0-.89-3l1.44-.83A6.18,6.18,0,0,1,173.82,456.14Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.77,453.74a2.4,2.4,0,0,1,.07-.57h0c-.87-.24-1.51.31-1.51,1.4a4.49,4.49,0,0,0,2,3.52c.94.55,1.74.26,2-.62a1.72,1.72,0,0,1-.52-.21A4.49,4.49,0,0,1,167.77,453.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.77,453.74a2.4,2.4,0,0,1,.07-.57h0c-.87-.24-1.51.31-1.51,1.4a4.49,4.49,0,0,0,2,3.52c.94.55,1.74.26,2-.62a1.72,1.72,0,0,1-.52-.21A4.49,4.49,0,0,1,167.77,453.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.35,451.72l-13.21-7.63v9.38l13.21,7.63c1.68,1,3,.18,3-1.75V457A6.66,6.66,0,0,0,169.35,451.72Zm-1,6.37a4.51,4.51,0,0,1-2-3.52c0-1.3.91-1.82,2-1.17a4.47,4.47,0,0,1,2,3.51C170.39,458.21,169.48,458.73,168.36,458.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.54,444.68l-13.21-7.63-1.44.83v9.38l13.21,7.63a2.12,2.12,0,0,0,2.15.21l1.44-.84a2.09,2.09,0,0,0,.88-1.95v-2.38A6.69,6.69,0,0,0,181.54,444.68Zm-2.43,2.51a4.47,4.47,0,0,1,2,3.52,2.23,2.23,0,0,1-.07.55,1.72,1.72,0,0,1-.52-.21,4.49,4.49,0,0,1-2-3.52,2.31,2.31,0,0,1,.07-.56A2.07,2.07,0,0,1,179.11,447.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.54,444.68l-13.22-7.63-1.43.83,13.21,7.63a6.69,6.69,0,0,1,3,5.25v2.38a2.09,2.09,0,0,1-.95,2l.07,0,1.44-.84a2.09,2.09,0,0,0,.88-1.95v-2.38A6.72,6.72,0,0,0,181.54,444.68Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,449.93v2.38a2.09,2.09,0,0,1-.88,1.95l-1.44.84-.06,0a2.09,2.09,0,0,0,.94-2v-2.38a6.21,6.21,0,0,0-.89-3l1.44-.83A6.18,6.18,0,0,1,184.57,449.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,449.93v2.38a2.09,2.09,0,0,1-.88,1.95l-1.44.84-.06,0a2.09,2.09,0,0,0,.94-2v-2.38a6.21,6.21,0,0,0-.89-3l1.44-.83A6.18,6.18,0,0,1,184.57,449.93Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,449.93v2.38a2.09,2.09,0,0,1-.88,1.95l-1.44.84-.06,0a2.09,2.09,0,0,0,.94-2v-2.38a6.21,6.21,0,0,0-.89-3l1.44-.83A6.18,6.18,0,0,1,184.57,449.93Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.52,447.53a2.31,2.31,0,0,1,.07-.56h0c-.86-.24-1.51.3-1.51,1.39a4.49,4.49,0,0,0,2,3.52c.94.55,1.74.26,2-.62a1.72,1.72,0,0,1-.52-.21A4.49,4.49,0,0,1,178.52,447.53Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.52,447.53a2.31,2.31,0,0,1,.07-.56h0c-.86-.24-1.51.3-1.51,1.39a4.49,4.49,0,0,0,2,3.52c.94.55,1.74.26,2-.62a1.72,1.72,0,0,1-.52-.21A4.49,4.49,0,0,1,178.52,447.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.11,445.51l-13.22-7.63v9.38l13.21,7.63c1.68,1,3,.19,3-1.75v-2.38A6.72,6.72,0,0,0,180.11,445.51Zm-1,6.37a4.49,4.49,0,0,1-2-3.52c0-1.29.91-1.82,2-1.17a4.47,4.47,0,0,1,2,3.52C181.14,452,180.23,452.53,179.11,451.88Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.05,392.14l37.6-21.75c3.88-2.23,5.82-5.17,5.82-8.1s0-5.23,0-5.23l-39-22a8.29,8.29,0,0,1-3.75-6.49V282.21l-65.68,38v46.37a8.25,8.25,0,0,0,3.74,6.48L199,392.14C206.73,396.61,219.3,396.61,227.05,392.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.05,392.14l37.6-21.75c3.88-2.23,5.82-5.17,5.82-8.1s0-5.23,0-5.23l-39-22a8.29,8.29,0,0,1-3.75-6.49V282.21l-65.68,38v46.37a8.25,8.25,0,0,0,3.74,6.48L199,392.14C206.73,396.61,219.3,396.61,227.05,392.14Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M177.81,374.74V380l-12-6.94a8.3,8.3,0,0,1-3.74-6.48V320.17L174.55,313c.25,3.17.54,6.46.8,9.66l-8.78,5.08v36.22a8.19,8.19,0,0,0,3.74,6.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.57,363.92a8.25,8.25,0,0,0,3.74,6.48L199,386.91c7.75,4.47,20.32,4.48,28.08,0l37.62-21.74c7.75-4.47,7.75-11.73,0-16.21L236,332.45a8.28,8.28,0,0,1-3.74-6.49V289.73l-65.68,38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.57,363.92a8.25,8.25,0,0,0,3.74,6.48L199,386.91c7.75,4.47,20.32,4.48,28.08,0l37.62-21.74c7.75-4.47,7.75-11.73,0-16.21L236,332.45a8.28,8.28,0,0,1-3.74-6.49V289.73l-65.68,38Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.62,336.85h0l-7.62-4.4a8.28,8.28,0,0,1-3.74-6.49V289.73l-65.68,38v36.23a8.25,8.25,0,0,0,3.74,6.48l7.5,4.33Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.48,357.06v5.23c0,2.94-2,5.86-5.82,8.11l-37.61,21.73a28.17,28.17,0,0,1-13.4,3.33v-5.21a28.17,28.17,0,0,0,13.4-3.33l37.61-21.75C268.53,362.94,270.48,360,270.48,357.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.48,357.06v5.23c0,2.94-2,5.86-5.82,8.11l-37.61,21.73a28.17,28.17,0,0,1-13.4,3.33v-5.21a28.17,28.17,0,0,0,13.4-3.33l37.61-21.75C268.53,362.94,270.48,360,270.48,357.06Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1,409a10,10,0,0,0,9.07-.17l254-146.66c2.58-1.49,4.67-5.12,4.67-4.1V26.72c0-7-2-10.54-4.39-11.94a10,10,0,0,0-9.06.17L61.4,161.61a10.32,10.32,0,0,0-4.68,8.1V401A10,10,0,0,0,61.1,409Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.17,408.78l254-146.66c2.58-1.49,4.68-5.12,4.68-4.11V26.71c0-7-2.1-8.19-4.68-6.7l-254,146.66a10.32,10.32,0,0,0-4.68,8.1v231.3C65.49,409.06,67.59,410.27,70.17,408.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.17,408.78l254-146.66c2.58-1.49,4.68-5.12,4.68-4.11V26.71c0-7-2.1-8.19-4.68-6.7l-254,146.66a10.32,10.32,0,0,0-4.68,8.1v231.3C65.49,409.06,67.59,410.27,70.17,408.78Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48,414.12a10.09,10.09,0,0,1-8.38-.18A10,10,0,0,1,56.71,406V391.28l8.78,5.08v14.71C65.49,413.79,67.22,415,69.48,414.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48,414.12a10.09,10.09,0,0,1-8.38-.18A10,10,0,0,1,56.71,406V391.28l8.78,5.08v14.71C65.49,413.79,67.22,415,69.48,414.12Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.49,396.36v14.7c0,3,2.1,4.2,4.68,2.7l254-146.65a10.35,10.35,0,0,0,4.68-8.11V244.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.49,396.32v14.74c0,3,2.1,4.2,4.68,2.7l254-146.65a10.35,10.35,0,0,0,4.68-8.11V244.26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.27,377.88V177.69a6.23,6.23,0,0,1,2.81-4.87L317.28,34.14c1.55-.89,2.81-.17,2.81,1.62V236a6.21,6.21,0,0,1-2.81,4.86L77.08,379.51C75.53,380.4,74.27,379.67,74.27,377.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.27,377.88V177.69a6.23,6.23,0,0,1,2.81-4.87L317.28,34.14c1.55-.89,2.81-.17,2.81,1.62V236a6.21,6.21,0,0,1-2.81,4.86L77.08,379.51C75.53,380.4,74.27,379.67,74.27,377.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.87,170.14a10,10,0,0,0-1.38,4.63V396.36l-8.78-5.08V169.71a9.69,9.69,0,0,1,1.37-4.62Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,21.94c-.33-2.41-2.28-3.28-4.64-1.93l-254,146.66a9.5,9.5,0,0,0-3.31,3.48l-8.78-5.07a9.66,9.66,0,0,1,3.31-3.48L315.42,15a10,10,0,0,1,9.07-.17A10.1,10.1,0,0,1,328.83,21.94Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4,390.08a4,4,0,0,1-1.83.55,4.55,4.55,0,0,1-2.68-.47,5,5,0,0,1-2.18-4l0-181.6,4.39,2.53V388.73c0,1.06.53,1.67,1.29,1.67A2.37,2.37,0,0,0,98.4,390.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.83,248a5.14,5.14,0,0,1-2.33,4L98.4,390.08c-1.28.74-2.32.14-2.32-1.35V192l6.41-3.7c1.28-.74,3.37-12,4.66-12.79l55.6-32.1c1.29-.74,4.32,7.61,5.6,6.86l171.48-99V248Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.75,53.1V248a4.1,4.1,0,0,1-1.79,3.1L97.86,389.15a1.13,1.13,0,0,1-.49.17c-.22,0-.22-.56-.22-.59V192.61l5.88-3.4c.93-.54,1.51-2.35,2.82-7a34.79,34.79,0,0,1,1.92-5.82l55.1-31.81a21.61,21.61,0,0,1,1.75,2.79c1.5,2.64,2.34,4,3.56,4a1.36,1.36,0,0,0,.71-.2L338.75,53.1M163.28,144.33h0M339.83,51.24l-171.48,99a.34.34,0,0,1-.17.05c-1.3,0-4-7-5.26-7a.33.33,0,0,0-.17,0l-55.6,32.1c-1.29.75-3.38,12-4.66,12.79L96.08,192V388.73c0,1.06.52,1.67,1.29,1.67a2,2,0,0,0,1-.32L337.5,252a5.14,5.14,0,0,0,2.33-4V51.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.89,199.15a5,5,0,0,1-2.19-4V177A5.15,5.15,0,0,1,94,173l239.1-138a4.36,4.36,0,0,1,6.69,3.87V57a5.12,5.12,0,0,1-2.33,4L98.4,199.07A5,5,0,0,1,93.89,199.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8,38.41c-.16-1.21-1.14-1.65-2.3-1L98.4,175.49a5.07,5.07,0,0,0-1.65,1.75l-4.37-2.53A4.86,4.86,0,0,1,94,173l239.1-138a4.34,4.34,0,0,1,6.67,3.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.75,177.24a4.72,4.72,0,0,0-.67,2.29v27.61l-4.39-2.53V177a2.62,2.62,0,0,1,0-.28,4.71,4.71,0,0,1,.09-.58,5.57,5.57,0,0,1,.58-1.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.82,38.78V51.24l-171.48,99c-1.28.75-2.32.14-2.32-1.34v-4.72c0-1.48-1-2.09-2.34-1.34l-56.54,32.64a5.15,5.15,0,0,0-2.33,4v4.71a5.17,5.17,0,0,1-2.33,4L96.08,192V179.53a5.17,5.17,0,0,1,2.32-4l239.1-138C338.78,36.69,339.82,37.3,339.82,38.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.9,46.59c1.62-.93,2.93-.17,2.93,1.7a6.49,6.49,0,0,1-2.93,5.08c-1.62.93-2.94.17-2.94-1.7A6.5,6.5,0,0,1,328.9,46.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.34,52.68c1.62-.93,2.93-.18,2.93,1.69a6.47,6.47,0,0,1-2.93,5.08c-1.62.94-2.93.18-2.93-1.69A6.49,6.49,0,0,1,318.34,52.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.78,58.77c1.62-.94,2.93-.18,2.93,1.69a6.49,6.49,0,0,1-2.93,5.08c-1.62.93-2.93.18-2.93-1.69A6.47,6.47,0,0,1,307.78,58.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.83,51.24V66.39L96.08,207.14V192l4.79-2.77c1.28-.74,1.71-1.87,2.32-4l1.63-5.64c.51-2,1-3.29,2.33-4l55.6-32.1c1.29-.74,2.3-.82,3.28.8l2,3.62c.73,1.26,1.1,2,2.38,1.26Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.08 191.98 96.08 207.14 91.69 204.61 91.69 189.47 96.08 191.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.77,193.08l-3.66,2.11,1.39-2.68a.68.68,0,0,0,0-.66c-.11-.13-.29,0-.42.2l-2,3.81v0s0,.09-.05.14,0,0,0,0a1.23,1.23,0,0,0,0,.19.72.72,0,0,0,0,.17s0,0,0,0a.56.56,0,0,0,.05.08h0l2,1.52a.16.16,0,0,0,.2,0,.55.55,0,0,0,.22-.28c.11-.25.09-.53,0-.62l-1.39-1.08,3.66-2.11a.77.77,0,0,0,.29-.62C107.06,193.11,106.93,193,106.77,193.08Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.82,191.31l3.66-2.11-1.4-1.07a.59.59,0,0,1,0-.63c.1-.25.29-.37.41-.28l2,1.53h0a.18.18,0,0,1,.06.08s0,0,0,0a.47.47,0,0,1,0,.17.69.69,0,0,1,0,.2s0,0,0,0l-.06.15h0l-2,3.82a.47.47,0,0,1-.19.22.16.16,0,0,1-.22,0,.65.65,0,0,1,0-.65l1.4-2.68-3.66,2.11c-.16.09-.29,0-.29-.28A.79.79,0,0,1,109.82,191.31Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.82,180.78c0-.22-.21-.2-.31,0l-.5,1.23c-.86-.09-1.89.74-2.59,2.22-.91,1.92-.91,4.19,0,5.06a1.29,1.29,0,0,0,1.64.1,4.56,4.56,0,0,0,1.65-2,.65.65,0,0,0,0-.64c-.12-.11-.3,0-.42.24-.68,1.43-1.78,2.07-2.45,1.42s-.68-2.35,0-3.78c.48-1,1.17-1.62,1.77-1.66l-.37.93c-.1.24,0,.46.14.36l1.49-1a.43.43,0,0,0,.17-.4Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.14,150.31l1.34-2.82a.9.9,0,0,0,0-.88c-.16-.15-.42,0-.57.33l-1.34,2.82-1.33-1.28c-.16-.15-.41,0-.57.33a.85.85,0,0,0,0,.88L160,151l-1.33,2.82a.85.85,0,0,0,0,.88.21.21,0,0,0,.28,0,.75.75,0,0,0,.29-.35l1.33-2.82,1.34,1.28a.21.21,0,0,0,.28,0,.75.75,0,0,0,.29-.35.9.9,0,0,0,0-.88Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.68,184.25v-4.72a5.14,5.14,0,0,1,2.33-4L324.38,62.74c1.29-.75,2.33-.14,2.33,1.34V68.8a5.14,5.14,0,0,1-2.33,4L129,185.59C127.72,186.34,126.68,185.73,126.68,184.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.21,73.2a.65.65,0,0,1-.21,0,.63.63,0,0,1-.35-.71l.23-1.91-.9-.65a.63.63,0,0,1-.24-.52,1,1,0,0,1,.38-.81l1.37-1.06a.32.32,0,0,0,.06-.11l.61-2a.85.85,0,0,1,.69-.65.52.52,0,0,1,.54.32h0l.51,1.09,1.16-.44a.52.52,0,0,1,.61.14.83.83,0,0,1,0,.94l-1,1.86a.45.45,0,0,0,0,.11l.24,1.68a1,1,0,0,1-.3.84.61.61,0,0,1-.54.21L323,71.36l-1.21,1.54A.69.69,0,0,1,321.21,73.2Zm-.66-3.9.9.65a.68.68,0,0,1,.24.64l-.16,1.28.81-1a.71.71,0,0,1,.62-.3l1.12.14a.38.38,0,0,0,0-.13l-.24-1.68a1.08,1.08,0,0,1,.12-.6l.87-1.63L324,67a.55.55,0,0,1-.71-.28l-.4-.86-.55,1.79a1,1,0,0,1-.34.51l-1.37,1A.29.29,0,0,0,320.55,69.3Zm.42,1.3Zm1.69-5.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.46,62.16a.8.8,0,0,1-.41-1.5l6.56-3.79a.81.81,0,1,1,.81,1.4l-6.56,3.78A.73.73,0,0,1,329.46,62.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,66a.8.8,0,0,1-.7-.4.82.82,0,0,1,.29-1.11l6.56-3.78a.81.81,0,0,1,1.11.29.8.8,0,0,1-.3,1.1l-6.56,3.79A.73.73,0,0,1,329.46,66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,69.74a.81.81,0,0,1-.41-1.51l6.56-3.79a.82.82,0,0,1,1.11.3.8.8,0,0,1-.3,1.1l-6.56,3.79A.83.83,0,0,1,329.46,69.74Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Search--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.27,211.38a.8.8,0,0,1-.41-1.5l6.56-3.79a.81.81,0,0,1,.81,1.4l-6.56,3.78A.76.76,0,0,1,103.27,211.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.27,215.17a.8.8,0,0,1-.7-.4.81.81,0,0,1,.29-1.11l6.56-3.78a.8.8,0,0,1,1.1.29.81.81,0,0,1-.29,1.11l-6.56,3.78A.76.76,0,0,1,103.27,215.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.27,219a.81.81,0,0,1-.41-1.51l6.56-3.78a.79.79,0,0,1,1.1.29.8.8,0,0,1-.29,1.1l-6.56,3.79A.86.86,0,0,1,103.27,219Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.45,178v5.81c0,1.19.84,1.67,1.87,1.08l77.93-45.06V129.69l-77.92,45.06A4.14,4.14,0,0,0,161.45,178Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.07,124c1-.6,1.87-.11,1.87,1.08v5.81a4.15,4.15,0,0,1-1.87,3.24l-9.82,5.67V129.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34,132l-1.09-.35a6.11,6.11,0,0,0,.17-1.41,2.57,2.57,0,0,0-1-2.34,1.55,1.55,0,0,0-1.59.08,5.6,5.6,0,0,0-2.19,4.56,2.57,2.57,0,0,0,1,2.34,1.39,1.39,0,0,0,.69.18,1.75,1.75,0,0,0,.9-.26,4.58,4.58,0,0,0,1.77-2.37l1.1.34a.25.25,0,0,0,.12,0,.4.4,0,0,0,.12-.79Zm-3.51,2.1a.77.77,0,0,1-.79.07,1.9,1.9,0,0,1-.59-1.63,4.92,4.92,0,0,1,1.78-3.86,1.05,1.05,0,0,1,.5-.15.51.51,0,0,1,.29.08,1.9,1.9,0,0,1,.59,1.63A4.92,4.92,0,0,1,246.83,134.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.06,194.53,117.81,201a4.1,4.1,0,0,0-1.87,3.22v5.79c0,1.19.84,1.67,1.87,1.08l11.25-6.51a4.11,4.11,0,0,0,1.86-3.23V195.6C130.92,194.42,130.09,193.93,129.06,194.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.71,81.56a9.7,9.7,0,0,0-4.38,7.59c0,2.8,2,3.93,4.38,2.54a9.71,9.71,0,0,0,4.39-7.6C329.1,81.29,327.13,80.16,324.71,81.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.2,86a.76.76,0,0,1-.39-.1,1,1,0,0,1-.42-.88,2.52,2.52,0,0,1,1.15-2h0a.87.87,0,0,1,1.4.81,2.54,2.54,0,0,1-1.16,2A1.23,1.23,0,0,1,324.2,86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.44,86.31a1.5,1.5,0,0,0-1.54.12l-.64.37a4.32,4.32,0,0,0-2,3.41v.46a2.47,2.47,0,0,0,2.42-.26,7,7,0,0,0,2.42-2.54v-.11A1.59,1.59,0,0,0,326.44,86.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.2,95.12V93.57c0-1.76-1.07-2.57-2.39-1.81h0a5.74,5.74,0,0,0-2.4,4.58v1.39a5.52,5.52,0,0,1-.81,2.7h0a1.48,1.48,0,0,0-.2.7h0c0,.45.27.65.6.46l5.61-3.23a1.47,1.47,0,0,0,.6-1.16h0a.59.59,0,0,0-.18-.47h0A1.63,1.63,0,0,1,309.2,95.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,99.8a2.77,2.77,0,0,1-1.15,2.2c-.64.36-1.16,0-1.16-.87Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.52,102.48a2.57,2.57,0,0,1,1-.34,1.32,1.32,0,0,1,.8.16,1.34,1.34,0,0,1,.53.61A2.54,2.54,0,0,1,291,104a4.21,4.21,0,0,1-.11,1,6.17,6.17,0,0,1-.28.86,7.85,7.85,0,0,1-.37.77l-.4.72c-.12.23-.24.47-.34.7a3.19,3.19,0,0,0-.21.69,1.14,1.14,0,0,1-.08.33.47.47,0,0,1-.16.2l-1.13.65c-.07,0-.13,0-.17,0a.3.3,0,0,1-.08-.23,3.13,3.13,0,0,1,.13-.91,6.61,6.61,0,0,1,.3-.85c.13-.27.26-.54.41-.79s.27-.5.4-.72.22-.45.31-.66a1.68,1.68,0,0,0,.12-.59c0-.28-.07-.46-.2-.53s-.35,0-.63.12a1.57,1.57,0,0,0-.59.54,2.9,2.9,0,0,0-.27.57l-.14.5a.54.54,0,0,1-.23.33l-1.13.65a.12.12,0,0,1-.14,0,.27.27,0,0,1-.06-.2,4.91,4.91,0,0,1,.18-1.15,7.62,7.62,0,0,1,.5-1.29,6.26,6.26,0,0,1,.8-1.22A4.14,4.14,0,0,1,288.52,102.48Zm.8,9.24a.73.73,0,0,1-.07.31.48.48,0,0,1-.18.21l-1.16.67a.12.12,0,0,1-.17,0,.3.3,0,0,1-.08-.23v-1.43a.71.71,0,0,1,.08-.31.44.44,0,0,1,.17-.22l1.16-.67a.14.14,0,0,1,.18,0,.28.28,0,0,1,.07.22Z",
    style: {
      fill: "#BA68C8"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--404--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--404--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.56,282.63a3.52,3.52,0,0,1-2.46-1,4.84,4.84,0,0,1-1.36-3.64v-7.4L138,282a3.82,3.82,0,0,1-2,.55,3.47,3.47,0,0,1-2.45-1,4.83,4.83,0,0,1-1.37-3.65V265.7a17.85,17.85,0,0,1,1.14-6.41L155.67,203a13,13,0,0,1,1.58-3,7.67,7.67,0,0,1,2.26-1.93l11.28-6.51a3.82,3.82,0,0,1,2-.55,3.5,3.5,0,0,1,2.45,1,4.84,4.84,0,0,1,1.37,3.64v39.83l2.67-1.54a3.8,3.8,0,0,1,2-.55,3.54,3.54,0,0,1,2.45,1A4.92,4.92,0,0,1,185,238.1v12.19a8.27,8.27,0,0,1-.84,3.59,6.22,6.22,0,0,1-2.43,2.84l-5.17,3V270a8.35,8.35,0,0,1-.84,3.6,6.23,6.23,0,0,1-2.43,2.84l-9.78,5.65A4,4,0,0,1,161.56,282.63Zm-6.88-34.47,3.43-2v-6.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.29,257.63l-.6,0a12.05,12.05,0,0,1-8.35-3.68,19.46,19.46,0,0,1-4.59-8.77,53.37,53.37,0,0,1-1.61-11.56c-.1-3.09-.15-6.49-.15-10.12s0-7.17.15-10.52a81.08,81.08,0,0,1,1.58-13.21A58.16,58.16,0,0,1,193.86,187a50.16,50.16,0,0,1,7-11.2,38,38,0,0,1,10.31-8.66c3.94-2.28,7.34-3.38,10.41-3.38h.6a12.14,12.14,0,0,1,8.35,3.68,19.57,19.57,0,0,1,4.59,8.77,53.55,53.55,0,0,1,1.61,11.56c.1,3.31.15,6.79.15,10.36s0,7-.15,10.28a82.2,82.2,0,0,1-1.58,13.21A58.88,58.88,0,0,1,231,234.38a50.07,50.07,0,0,1-7,11.2,38.2,38.2,0,0,1-10.31,8.67C209.76,256.52,206.35,257.63,203.29,257.63ZM215.82,189a4.69,4.69,0,0,0-2.12.81,10.4,10.4,0,0,0-3,2.57,13.88,13.88,0,0,0-2,3.56,22.43,22.43,0,0,0-1.2,4.48,36.54,36.54,0,0,0-.49,5.24c-.25,6.45-.25,12.88,0,19.16a29.78,29.78,0,0,0,.45,4.64,5.77,5.77,0,0,0,.88,2.38.94.94,0,0,0,.72.44h0a4.57,4.57,0,0,0,2.18-.8,10.57,10.57,0,0,0,3-2.58,14.37,14.37,0,0,0,2.07-3.6,20.29,20.29,0,0,0,1.2-4.43,43.14,43.14,0,0,0,.45-5.25c.2-6.55.2-13,0-19.17a34.47,34.47,0,0,0-.52-4.59,6.49,6.49,0,0,0-.89-2.46.81.81,0,0,0-.63-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.23,219.31a3.52,3.52,0,0,1-2.46-1,4.84,4.84,0,0,1-1.36-3.64v-7.4l-19.78,11.42a3.79,3.79,0,0,1-1.94.55,3.48,3.48,0,0,1-2.46-1,4.83,4.83,0,0,1-1.36-3.64V202.37A17.62,17.62,0,0,1,243,196l22.34-56.27a13,13,0,0,1,1.57-3,7.8,7.8,0,0,1,2.26-1.93l11.28-6.51a3.85,3.85,0,0,1,2-.55,3.47,3.47,0,0,1,2.45,1,4.84,4.84,0,0,1,1.37,3.64v39.83l2.68-1.54a3.76,3.76,0,0,1,1.94-.55,3.54,3.54,0,0,1,2.45,1,4.88,4.88,0,0,1,1.37,3.66V187a8.42,8.42,0,0,1-.83,3.6,6.28,6.28,0,0,1-2.43,2.84l-5.18,3v10.28a8.48,8.48,0,0,1-.83,3.6,6.24,6.24,0,0,1-2.44,2.84l-9.78,5.65A3.92,3.92,0,0,1,271.23,219.31Zm-6.87-34.47,3.43-2v-6.65Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--404--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.48,241.3a1.1,1.1,0,0,0-.25-.19l-7.59-4.38v-36a2.47,2.47,0,0,0-.6-1.84l-.24-.18L173.69,194a1.13,1.13,0,0,0-1.19.08l-11.28,6.51a5.23,5.23,0,0,0-1.53,1.29,9.91,9.91,0,0,0-1.23,2.38l-22.34,56.25a15.06,15.06,0,0,0-1,5.5v12.19a2.44,2.44,0,0,0,.6,1.84,1.1,1.1,0,0,0,.25.19l8.11,4.69a1.11,1.11,0,0,0,1.18-.09L160.7,276v2.35a2.51,2.51,0,0,0,.59,1.84l.24.18,8.13,4.69a1.11,1.11,0,0,0,1.18-.08l9.78-5.65a3.82,3.82,0,0,0,1.42-1.74,5.83,5.83,0,0,0,.6-2.53V263.31l6.42-3.71a3.72,3.72,0,0,0,1.42-1.74,5.83,5.83,0,0,0,.6-2.53V243.14A2.47,2.47,0,0,0,190.48,241.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.76,206.6l0,.14a11.47,11.47,0,0,0-1.14,2.25l-22.33,56.25a12.76,12.76,0,0,0-.66,2.31l-8.18-4.72a14.23,14.23,0,0,1,.65-2.28l22.33-56.25a10.46,10.46,0,0,1,1.24-2.38h0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,284.9c-.92-.53-7.69-4.44-8-4.62a1.46,1.46,0,0,1-.25-.2,2.44,2.44,0,0,1-.6-1.84V266.06a16.53,16.53,0,0,1,.32-3.2l8.12,4.69a15.72,15.72,0,0,0-.31,3.2v12.19a2.47,2.47,0,0,0,.59,1.83Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.2 231.52 169.2 252.68 162.36 248.73 169.2 231.52",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.2 252.68 158.29 258.97 162.36 248.73 169.2 252.68",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,284.86l.14.12-8-4.62a.88.88,0,0,1-.24-.19,2.45,2.45,0,0,1-.6-1.84V276l8.12-4.69V283A2.45,2.45,0,0,0,169.42,284.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.14,241.07a1.14,1.14,0,0,0-1.07.13l-6.43,3.71v-8.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.75,198.7a1.14,1.14,0,0,0-1.13.11l-11.27,6.51a5.34,5.34,0,0,0-1.53,1.28l-8.12-4.69a5.29,5.29,0,0,1,1.52-1.28l11.28-6.51a1.1,1.1,0,0,1,1.19-.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.84,285a1.08,1.08,0,0,1-1.42-.1,2.45,2.45,0,0,1-.6-1.84V271.29l-23.53,13.58a1.07,1.07,0,0,1-1.42-.1,2.44,2.44,0,0,1-.6-1.84V270.74a15.07,15.07,0,0,1,1-5.5L166.58,209a10.94,10.94,0,0,1,1.23-2.38,5.5,5.5,0,0,1,1.53-1.29l11.28-6.51a1.08,1.08,0,0,1,1.42.1,2.47,2.47,0,0,1,.6,1.84v44.16l6.42-3.71a1.1,1.1,0,0,1,1.42.1,2.47,2.47,0,0,1,.6,1.84v12.19a5.83,5.83,0,0,1-.6,2.53,3.72,3.72,0,0,1-1.42,1.74l-6.42,3.71V275a5.83,5.83,0,0,1-.6,2.53,3.82,3.82,0,0,1-1.42,1.74Zm-1.65-32.29V231.51L158.29,259Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.84,192.9a50.6,50.6,0,0,0-1.53-11,17,17,0,0,0-4-7.66,9.41,9.41,0,0,0-2-1.6c-1.35-.8-7.39-4.27-8.13-4.7a10,10,0,0,0-4.64-1.31q-4-.21-9.63,3a35.25,35.25,0,0,0-9.64,8.09,47.36,47.36,0,0,0-6.68,10.65,55.55,55.55,0,0,0-4,12.23,78.4,78.4,0,0,0-1.53,12.79q-.15,5-.15,10.43c0,3.61.05,6.95.15,10a50.42,50.42,0,0,0,1.53,11,17,17,0,0,0,4,7.67,9.56,9.56,0,0,0,2,1.59c1.36.8,7.48,4.33,8.26,4.77a10.06,10.06,0,0,0,4.53,1.25c2.68.14,5.9-.87,9.63-3a35.6,35.6,0,0,0,9.64-8.09,47.72,47.72,0,0,0,6.68-10.65,55.55,55.55,0,0,0,4-12.23,78.4,78.4,0,0,0,1.53-12.79q.15-4.8.15-10.2T242.84,192.9Zm-29.51,40.87A32.16,32.16,0,0,1,213,230q-.37-9.56,0-19.32a40,40,0,0,1,.52-5.59,25,25,0,0,1,1.35-5,16.14,16.14,0,0,1,2.39-4.2,12.85,12.85,0,0,1,3.24-2.88c.17,1.14.29,2.38.36,3.73q.3,9.38,0,19.32a42.74,42.74,0,0,1-.49,5.57,22.56,22.56,0,0,1-1.34,5,16.94,16.94,0,0,1-2.43,4.22A12.78,12.78,0,0,1,213.33,233.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.66,258.79l-8-4.64a9.88,9.88,0,0,1-2-1.6,17,17,0,0,1-4-7.66,50.52,50.52,0,0,1-1.53-11q-.15-4.63-.15-10t.15-10.44a78.4,78.4,0,0,1,1.53-12.79,55,55,0,0,1,2.52-8.75l8.11,4.7a56,56,0,0,0-2.5,8.74,77.35,77.35,0,0,0-1.54,12.79q-.15,5-.15,10.44t.15,10a49.89,49.89,0,0,0,1.54,11,16.93,16.93,0,0,0,4,7.66A9.56,9.56,0,0,0,206.66,258.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,172.45a10.38,10.38,0,0,0-4.34-1.15q-4-.2-9.64,3a35.56,35.56,0,0,0-9.63,8.1,47.69,47.69,0,0,0-6.69,10.64c-.27.58-.52,1.17-.77,1.77s-.45,1.14-.67,1.72h0l-8.11-4.7c.19-.51.39-1,.6-1.52.27-.66.54-1.31.84-2a48.31,48.31,0,0,1,6.68-10.65,35.75,35.75,0,0,1,9.64-8.09c3.73-2.16,7-3.16,9.64-3a10.07,10.07,0,0,1,4.63,1.31C227.88,168.33,233.22,171.4,235,172.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,220.78a44.55,44.55,0,0,1-.49,5.57,22.42,22.42,0,0,1-1.34,5,16.47,16.47,0,0,1-.93,1.94l-8.12-4.69a18.16,18.16,0,0,0,.92-1.94,23,23,0,0,0,1.35-5,44.59,44.59,0,0,0,.48-5.57q.3-9.94,0-19.32c-.07-1.35-.19-2.59-.35-3.73,0,0,.21-.15.48-.31a6.24,6.24,0,0,1,3.74-1.12,3.33,3.33,0,0,1,2.39,1.44,8.77,8.77,0,0,1,1.31,3.44,38.72,38.72,0,0,1,.56,5Q229.32,210.84,229,220.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.27,233.26a16,16,0,0,1-1.5,2.28,12.77,12.77,0,0,1-3.74,3.19,6.29,6.29,0,0,1-3.73,1.12,3.39,3.39,0,0,1-2.43-1.41,8.18,8.18,0,0,1-1.34-3.42c-.08-.4-.14-.82-.2-1.25a12.61,12.61,0,0,0,3.31-2.92,16.08,16.08,0,0,0,1.51-2.28Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,174.33q5.61-3.24,9.64-3a9.66,9.66,0,0,1,6.68,2.92,17,17,0,0,1,4,7.66,50.6,50.6,0,0,1,1.53,11q.15,4.86.15,10.27t-.15,10.2a78.4,78.4,0,0,1-1.53,12.79,55.55,55.55,0,0,1-4,12.23A48.08,48.08,0,0,1,230.67,249a35.6,35.6,0,0,1-9.64,8.09c-3.73,2.16-6.95,3.17-9.63,3a9.66,9.66,0,0,1-6.69-2.92,17,17,0,0,1-4-7.67,50.42,50.42,0,0,1-1.53-11c-.1-3.09-.15-6.43-.15-10s.05-7.08.15-10.43a78.4,78.4,0,0,1,1.53-12.79,55.55,55.55,0,0,1,4-12.23,47.76,47.76,0,0,1,6.69-10.65A35.2,35.2,0,0,1,221,174.33Zm8,46.45q.3-9.94,0-19.32a37,37,0,0,0-.56-5,8.78,8.78,0,0,0-1.3-3.44,3.26,3.26,0,0,0-2.39-1.44,6.39,6.39,0,0,0-3.74,1.12,12.73,12.73,0,0,0-3.73,3.19,16.14,16.14,0,0,0-2.39,4.2,25,25,0,0,0-1.35,5,40,40,0,0,0-.52,5.59q-.37,9.76,0,19.32a32.28,32.28,0,0,0,.48,5,8.07,8.07,0,0,0,1.35,3.42,3.4,3.4,0,0,0,2.43,1.42,6.38,6.38,0,0,0,3.73-1.12,13.06,13.06,0,0,0,3.74-3.19,17.22,17.22,0,0,0,2.42-4.22,22.58,22.58,0,0,0,1.35-5A44.59,44.59,0,0,0,229,220.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.16,178a1.15,1.15,0,0,0-.26-.19l-7.59-4.38v-36a2.49,2.49,0,0,0-.59-1.84,1.25,1.25,0,0,0-.24-.18l-8.12-4.69a1.13,1.13,0,0,0-1.19.08l-11.28,6.51a5.19,5.19,0,0,0-1.53,1.29,10.7,10.7,0,0,0-1.23,2.38L245.8,197.23a15.06,15.06,0,0,0-1,5.5v12.19a2.45,2.45,0,0,0,.59,1.84,1.15,1.15,0,0,0,.26.19l8.11,4.69a1.11,1.11,0,0,0,1.18-.09l15.4-8.89V215a2.47,2.47,0,0,0,.6,1.84l.24.18,8.12,4.69a1.13,1.13,0,0,0,1.18-.08L290.3,216a3.89,3.89,0,0,0,1.42-1.74,6,6,0,0,0,.59-2.53V200l6.43-3.71a3.78,3.78,0,0,0,1.42-1.74,6,6,0,0,0,.59-2.53V179.82A2.51,2.51,0,0,0,300.16,178Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.43,143.28l0,.14a11.47,11.47,0,0,0-1.14,2.25l-22.33,56.25a12.76,12.76,0,0,0-.66,2.31l-8.18-4.72a14.23,14.23,0,0,1,.65-2.28L268.06,141a10.46,10.46,0,0,1,1.24-2.38h0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.69,221.58c-.92-.53-7.69-4.44-8-4.62a1.46,1.46,0,0,1-.25-.2,2.44,2.44,0,0,1-.6-1.84V202.74a16.53,16.53,0,0,1,.32-3.2l8.12,4.69a15.72,15.72,0,0,0-.31,3.2v12.19a2.47,2.47,0,0,0,.59,1.83Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.87 168.2 278.87 189.36 272.03 185.41 278.87 168.2",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.87 189.36 267.96 195.65 272.03 185.41 278.87 189.36",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.09,221.54l.14.12-8-4.62a.88.88,0,0,1-.24-.19,2.45,2.45,0,0,1-.6-1.84v-2.35l8.12-4.69V219.7A2.45,2.45,0,0,0,279.09,221.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.81,177.75a1.14,1.14,0,0,0-1.07.13l-6.43,3.71v-8.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.42,135.38a1.14,1.14,0,0,0-1.13.11L279,142a5.34,5.34,0,0,0-1.53,1.28l-8.12-4.69a5.29,5.29,0,0,1,1.52-1.28l11.28-6.51a1.1,1.1,0,0,1,1.19-.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.51,221.64a1.08,1.08,0,0,1-1.42-.1,2.47,2.47,0,0,1-.59-1.84V208L255,221.55a1.07,1.07,0,0,1-1.42-.1,2.44,2.44,0,0,1-.6-1.84V207.42a15.06,15.06,0,0,1,1-5.5l22.33-56.25a10.24,10.24,0,0,1,1.24-2.38A5.08,5.08,0,0,1,279,142l11.28-6.51a1.09,1.09,0,0,1,1.42.1,2.49,2.49,0,0,1,.59,1.84v44.16l6.43-3.71a1.09,1.09,0,0,1,1.42.1,2.51,2.51,0,0,1,.59,1.84V192a6,6,0,0,1-.59,2.53,3.78,3.78,0,0,1-1.42,1.74L292.31,200v11.73a6,6,0,0,1-.59,2.53A3.89,3.89,0,0,1,290.3,216Zm-1.64-32.29V168.19L268,195.65Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,292.43a.25.25,0,0,1,.32,0,.57.57,0,0,1,.14.42v2.76a1.41,1.41,0,0,1-.14.58.81.81,0,0,1-.32.39l-8,4.63a.25.25,0,0,1-.32,0,.57.57,0,0,1-.13-.42V284a1.31,1.31,0,0,1,.13-.57.86.86,0,0,1,.32-.39l7.89-4.56a.24.24,0,0,1,.32,0,.53.53,0,0,1,.13.41v2.77a1.31,1.31,0,0,1-.13.57.86.86,0,0,1-.32.39l-5.21,3v2.81l4.83-2.79a.27.27,0,0,1,.33,0,.57.57,0,0,1,.13.42v2.76a1.31,1.31,0,0,1-.13.57.91.91,0,0,1-.33.4l-4.83,2.79v2.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09,273.83a5.94,5.94,0,0,1,2-.79,2.12,2.12,0,0,1,1.5.23,2.33,2.33,0,0,1,.95,1.31,7.61,7.61,0,0,1,.33,2.46,11.24,11.24,0,0,1-.53,3.54,9.08,9.08,0,0,1-1.48,2.83l2.09,5a.56.56,0,0,1,.05.25,1,1,0,0,1-.11.47.72.72,0,0,1-.26.32l-2.3,1.33c-.22.13-.38.14-.48,0a1.23,1.23,0,0,1-.23-.33L208.73,286l-1.55.89v5.58a1.33,1.33,0,0,1-.14.57,1,1,0,0,1-.32.4l-2.22,1.27a.23.23,0,0,1-.32,0,.54.54,0,0,1-.13-.42V277.44a1.31,1.31,0,0,1,.13-.57.9.9,0,0,1,.32-.4Zm-1.91,9,1.91-1.1a3.62,3.62,0,0,0,1.17-1.1,3.1,3.1,0,0,0,.47-1.78c0-.73-.16-1.14-.47-1.24a1.5,1.5,0,0,0-1.17.26L207.18,279Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.27,266.79a6.12,6.12,0,0,1,2-.79,2.21,2.21,0,0,1,1.49.23,2.4,2.4,0,0,1,1,1.32A7.59,7.59,0,0,1,226,270a11.61,11.61,0,0,1-.52,3.55,9.27,9.27,0,0,1-1.49,2.82l2.09,5a.62.62,0,0,1,.06.26,1.15,1.15,0,0,1-.11.47.8.8,0,0,1-.27.32l-2.3,1.33c-.22.13-.38.14-.48,0a1.13,1.13,0,0,1-.23-.34L220.91,279l-1.55.9v5.58a1.33,1.33,0,0,1-.14.57.86.86,0,0,1-.32.39l-2.22,1.28a.24.24,0,0,1-.32,0,.57.57,0,0,1-.13-.42V270.41a1.36,1.36,0,0,1,.13-.58.86.86,0,0,1,.32-.39Zm-1.91,9,1.91-1.11a3.39,3.39,0,0,0,1.17-1.09,3.12,3.12,0,0,0,.47-1.78c0-.73-.16-1.14-.47-1.24a1.51,1.51,0,0,0-1.17.26l-1.91,1.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,269.69a14.63,14.63,0,0,1,.41-3,14.12,14.12,0,0,1,1-2.84,12,12,0,0,1,1.63-2.45,8.43,8.43,0,0,1,2.21-1.83,4.44,4.44,0,0,1,2.2-.71,2.44,2.44,0,0,1,1.63.57,3.56,3.56,0,0,1,1,1.64,8.84,8.84,0,0,1,.41,2.51c0,.73,0,1.51,0,2.32s0,1.59,0,2.32a14.63,14.63,0,0,1-.41,3,13.82,13.82,0,0,1-1,2.85,11.48,11.48,0,0,1-1.63,2.45,8.65,8.65,0,0,1-2.2,1.82,4.61,4.61,0,0,1-2.21.73,2.44,2.44,0,0,1-1.63-.57,3.84,3.84,0,0,1-1-1.66,8.84,8.84,0,0,1-.41-2.51c0-.7,0-1.46,0-2.27S228,270.45,228,269.69Zm7.43.22c0-.32,0-.67,0-1.06s0-.78,0-1.18,0-.78,0-1.15,0-.69,0-1a5.26,5.26,0,0,0-.18-1.1,1.67,1.67,0,0,0-.41-.72,1,1,0,0,0-.65-.26,1.79,1.79,0,0,0-.91.3,3.37,3.37,0,0,0-.92.76,4.59,4.59,0,0,0-.65,1,5.74,5.74,0,0,0-.4,1.19,6.9,6.9,0,0,0-.18,1.3c0,.31,0,.65,0,1s0,.77,0,1.17,0,.79,0,1.16,0,.72,0,1a2.9,2.9,0,0,0,.58,1.83c.35.37.87.36,1.57-.05a3.63,3.63,0,0,0,1.55-1.75A7.39,7.39,0,0,0,235.45,269.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,252.5a6.12,6.12,0,0,1,2-.79,2.21,2.21,0,0,1,1.49.23,2.4,2.4,0,0,1,1,1.32,7.59,7.59,0,0,1,.33,2.45,11.61,11.61,0,0,1-.52,3.55,9.44,9.44,0,0,1-1.49,2.83l2.09,5a.62.62,0,0,1,.06.26,1.15,1.15,0,0,1-.11.47.8.8,0,0,1-.27.32l-2.3,1.33c-.22.13-.38.14-.48,0a1.13,1.13,0,0,1-.23-.34l-1.88-4.49-1.55.9v5.58a1.33,1.33,0,0,1-.14.57.86.86,0,0,1-.32.39l-2.22,1.28a.24.24,0,0,1-.32,0,.57.57,0,0,1-.13-.42V256.12a1.39,1.39,0,0,1,.13-.58.86.86,0,0,1,.32-.39Zm-1.91,9,1.91-1.11a3.51,3.51,0,0,0,1.18-1.09,3.12,3.12,0,0,0,.46-1.78c0-.73-.15-1.14-.46-1.24a1.52,1.52,0,0,0-1.18.26l-1.91,1.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.71,321.23c1-.6,1.86-.69,2.44-.26s.87,1.36.87,2.83a8.16,8.16,0,0,1-.87,3.85,6.24,6.24,0,0,1-2.44,2.57l-2.07,1.19v4.46a1,1,0,0,1-.11.43.66.66,0,0,1-.24.31l-1,.6a.18.18,0,0,1-.25,0,.4.4,0,0,1-.1-.31V324a1,1,0,0,1,.1-.44.69.69,0,0,1,.25-.3Zm-2.07,7.69,2-1.16a3.12,3.12,0,0,0,1.62-2.95c0-.75-.15-1.18-.44-1.3a1.42,1.42,0,0,0-1.18.26l-2,1.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.48,316.18c.13-.08.24-.09.31,0a.88.88,0,0,1,.18.4l3.18,10.78s0,.08,0,.13a1.13,1.13,0,0,1-.1.44.65.65,0,0,1-.25.3l-.93.54c-.18.1-.3.12-.37,0a.56.56,0,0,1-.14-.25l-.56-1.89L176.72,329l-.56,2.53a2.85,2.85,0,0,1-.14.41.8.8,0,0,1-.37.38l-.93.54a.19.19,0,0,1-.25,0,.44.44,0,0,1-.1-.32.71.71,0,0,1,0-.15L177.56,318a2.82,2.82,0,0,1,.18-.61.71.71,0,0,1,.31-.35Zm.71,8.35-1.43-4.87-1.42,6.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.16,318.64a11.36,11.36,0,0,1,.28-2.35,10.31,10.31,0,0,1,.75-2.13,8.27,8.27,0,0,1,1.22-1.8,7,7,0,0,1,1.68-1.36,3.7,3.7,0,0,1,1.86-.62,1.84,1.84,0,0,1,1.16.4,2,2,0,0,1,.61,1,3.9,3.9,0,0,1,.2,1,.87.87,0,0,1-.09.45.68.68,0,0,1-.26.29l-1,.61c-.09.05-.17.06-.22,0a.34.34,0,0,1-.13-.16,2.57,2.57,0,0,0-.13-.27,1,1,0,0,0-.35-.36,1.18,1.18,0,0,0-.63-.15,2.06,2.06,0,0,0-1,.33,4,4,0,0,0-1.56,1.71,5.72,5.72,0,0,0-.62,2.52c0,.52,0,1.07,0,1.64s0,1.12,0,1.61c0,1.09.23,1.78.62,2a1.41,1.41,0,0,0,1.56-.15,4.66,4.66,0,0,0,.88-.67,3.76,3.76,0,0,0,.69-.92,4.22,4.22,0,0,0,.45-1.21,6.54,6.54,0,0,0,.17-1.54v-.16l-1.59.92a.19.19,0,0,1-.24,0,.42.42,0,0,1-.1-.32v-1.42a1,1,0,0,1,.1-.44.76.76,0,0,1,.24-.3l3-1.72a.17.17,0,0,1,.24,0,.41.41,0,0,1,.11.32v2.19a11.5,11.5,0,0,1-.25,2.35,9,9,0,0,1-.74,2.16,8.28,8.28,0,0,1-1.23,1.85,6.9,6.9,0,0,1-1.72,1.41,3.87,3.87,0,0,1-1.72.59,1.63,1.63,0,0,1-1.2-.43,2.71,2.71,0,0,1-.73-1.3,7.61,7.61,0,0,1-.28-2c0-.25,0-.53,0-.83s0-.62,0-.94,0-.63,0-.94S184.15,318.9,184.16,318.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,315.79a.18.18,0,0,1,.25,0,.41.41,0,0,1,.11.32v1.41a1,1,0,0,1-.11.44.59.59,0,0,1-.25.3l-5.69,3.29a.18.18,0,0,1-.24,0,.41.41,0,0,1-.11-.32V308.34a1,1,0,0,1,.11-.44.63.63,0,0,1,.24-.3l5.59-3.23a.19.19,0,0,1,.25,0,.42.42,0,0,1,.1.32v1.42a1,1,0,0,1-.1.43.67.67,0,0,1-.25.31l-4.19,2.41v3.18l3.91-2.26a.19.19,0,0,1,.24,0,.43.43,0,0,1,.11.32V312a1,1,0,0,1-.11.44.76.76,0,0,1-.24.3L195.73,315v3.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.47,311.67c-.15.09-.26.09-.33,0l-.17-.18-3.63-6.21v8.22a1,1,0,0,1-.11.44.63.63,0,0,1-.24.3l-1.05.61a.18.18,0,0,1-.25,0,.41.41,0,0,1-.1-.32V301.64a1,1,0,0,1,.1-.44.59.59,0,0,1,.25-.3l.9-.53c.15-.08.26-.09.34,0a1.26,1.26,0,0,1,.17.18l3.63,6.21v-8.22a1,1,0,0,1,.1-.44.65.65,0,0,1,.25-.3l1-.61a.18.18,0,0,1,.25,0,.45.45,0,0,1,.1.32v12.89a1.21,1.21,0,0,1-.1.44.65.65,0,0,1-.25.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.77,301a12.56,12.56,0,0,1,.27-2.27,10,10,0,0,1,.71-2.12,7.92,7.92,0,0,1,1.17-1.83,6,6,0,0,1,1.66-1.39,3.31,3.31,0,0,1,1.64-.53,1.64,1.64,0,0,1,1.17.48,3,3,0,0,1,.71,1.31,7.86,7.86,0,0,1,.29,1.95c0,.25,0,.52,0,.83v1.89c0,.31,0,.59,0,.85a13.41,13.41,0,0,1-.28,2.27,9.78,9.78,0,0,1-.71,2.12,7.92,7.92,0,0,1-1.17,1.83,6.22,6.22,0,0,1-1.65,1.37,3.33,3.33,0,0,1-1.66.54,1.67,1.67,0,0,1-1.17-.47,3,3,0,0,1-.71-1.31,8.05,8.05,0,0,1-.27-1.95c0-.24,0-.52,0-.82s0-.62,0-.95,0-.64,0-.95S214.76,301.27,214.77,301Zm5.87-3.29a2.64,2.64,0,0,0-.6-1.88,1.21,1.21,0,0,0-1.46.05,3.74,3.74,0,0,0-1.46,1.64,6,6,0,0,0-.6,2.57c0,.52,0,1.08,0,1.7s0,1.18,0,1.67a2.5,2.5,0,0,0,.6,1.87c.37.31.85.29,1.46-.06a3.8,3.8,0,0,0,1.46-1.62,6.36,6.36,0,0,0,.6-2.57c0-.51,0-1.08,0-1.7S220.65,298.22,220.64,297.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.28,286.84a.19.19,0,0,1,.25,0,.42.42,0,0,1,.1.32v1.42a1,1,0,0,1-.1.44.69.69,0,0,1-.25.3L228,290.68v10.94a1.13,1.13,0,0,1-.1.44.65.65,0,0,1-.25.3l-1,.61a.19.19,0,0,1-.25,0,.41.41,0,0,1-.1-.32V291.7L223.87,293a.18.18,0,0,1-.25,0,.4.4,0,0,1-.1-.31v-1.42a1,1,0,0,1,.1-.44.59.59,0,0,1,.25-.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1,280.6a.18.18,0,0,1,.24,0,.41.41,0,0,1,.11.32v1.41a1,1,0,0,1-.11.44.63.63,0,0,1-.24.3L237,285.48v3.87l3.88-2.23a.18.18,0,0,1,.24,0,.44.44,0,0,1,.11.32v1.42a1,1,0,0,1-.11.44.63.63,0,0,1-.24.3L237,291.85v4.57a1,1,0,0,1-.1.44.59.59,0,0,1-.25.3l-1.05.61a.19.19,0,0,1-.25,0,.42.42,0,0,1-.1-.32V284.54a1,1,0,0,1,.1-.44.59.59,0,0,1,.25-.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.86,284.79a12.58,12.58,0,0,1,.28-2.27,9.77,9.77,0,0,1,.7-2.12,8.27,8.27,0,0,1,1.17-1.83,6.18,6.18,0,0,1,1.66-1.39,3.32,3.32,0,0,1,1.65-.53,1.63,1.63,0,0,1,1.16.48,3.15,3.15,0,0,1,.72,1.31,7.88,7.88,0,0,1,.28,1.95c0,.25,0,.52,0,.83s0,.62,0,.94,0,.64,0,.95,0,.6,0,.85a12.47,12.47,0,0,1-.28,2.27,9.77,9.77,0,0,1-.7,2.12,8,8,0,0,1-1.18,1.83,6.22,6.22,0,0,1-1.65,1.37,3.3,3.3,0,0,1-1.66.54,1.69,1.69,0,0,1-1.17-.47,2.92,2.92,0,0,1-.7-1.31,8,8,0,0,1-.28-1.95c0-.24,0-.52,0-.82s0-.62,0-1,0-.64,0-.95S242.85,285.05,242.86,284.79Zm5.87-3.29a2.55,2.55,0,0,0-.6-1.88c-.37-.31-.86-.29-1.46.06a3.77,3.77,0,0,0-1.46,1.63,6,6,0,0,0-.6,2.57c0,.52,0,1.08,0,1.7s0,1.18,0,1.67a2.5,2.5,0,0,0,.6,1.87c.37.31.86.29,1.46-.06a3.8,3.8,0,0,0,1.46-1.62,6,6,0,0,0,.6-2.57c0-.51,0-1.08,0-1.7S248.75,282,248.73,281.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.53,270a.19.19,0,0,1,.25,0,.44.44,0,0,1,.1.32v8.19a12.21,12.21,0,0,1-.23,2.37A9.77,9.77,0,0,1,259,283a7.41,7.41,0,0,1-1.17,1.78,6.43,6.43,0,0,1-1.62,1.32,3.41,3.41,0,0,1-1.63.55,1.59,1.59,0,0,1-1.16-.43,2.75,2.75,0,0,1-.69-1.32,8.47,8.47,0,0,1-.23-2.1v-8.19a1.06,1.06,0,0,1,.11-.44.68.68,0,0,1,.24-.3l1-.61a.19.19,0,0,1,.25,0,.44.44,0,0,1,.1.32v8.08a4.7,4.7,0,0,0,.15,1.32,1.38,1.38,0,0,0,.4.72.83.83,0,0,0,.62.18,2.26,2.26,0,0,0,.79-.29,3.63,3.63,0,0,0,1.43-1.53,5,5,0,0,0,.4-1.19,6.67,6.67,0,0,0,.15-1.48V271.3a1,1,0,0,1,.11-.44.73.73,0,0,1,.24-.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.05,279c-.15.08-.26.09-.34,0a1.31,1.31,0,0,1-.17-.18l-3.63-6.2v8.22a1,1,0,0,1-.1.44.64.64,0,0,1-.25.3l-1.05.61a.18.18,0,0,1-.24,0,.43.43,0,0,1-.11-.32V269a1,1,0,0,1,.11-.43.73.73,0,0,1,.24-.31l.91-.52c.15-.08.26-.09.34,0l.17.18,3.63,6.2v-8.22a1,1,0,0,1,.1-.44.76.76,0,0,1,.24-.3l1.06-.61a.19.19,0,0,1,.24,0,.44.44,0,0,1,.11.32v12.89a1,1,0,0,1-.11.44.73.73,0,0,1-.24.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.2,260.91a3.79,3.79,0,0,1,1.67-.58,1.6,1.6,0,0,1,1.18.43,2.86,2.86,0,0,1,.72,1.32,8.64,8.64,0,0,1,.31,2.1c0,1,0,1.95,0,2.95a13.56,13.56,0,0,1-.31,2.45,9.36,9.36,0,0,1-.71,2.15,7.8,7.8,0,0,1-1.16,1.78,6.55,6.55,0,0,1-1.63,1.33L272,276.73a.18.18,0,0,1-.24,0,.43.43,0,0,1-.11-.32V263.5a1,1,0,0,1,.11-.44.58.58,0,0,1,.24-.3Zm2.13,4.28a4.92,4.92,0,0,0-.16-1.1,1.66,1.66,0,0,0-.4-.72.89.89,0,0,0-.67-.25,1.93,1.93,0,0,0-1,.32l-1.74,1v9l1.8-1a3.22,3.22,0,0,0,.92-.76,4.19,4.19,0,0,0,.65-1,5.55,5.55,0,0,0,.4-1.19,7.84,7.84,0,0,0,.16-1.29C277.36,267.14,277.36,266.15,277.33,265.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.33,48.71l-50.21,29a2.85,2.85,0,0,0-1.3,2.24v64.2a2.82,2.82,0,0,0,1.3,2.23l4.64,2.6a2.88,2.88,0,0,0,2.59,0l50.22-29a2.89,2.89,0,0,0,1.29-2.24V53.52a2.8,2.8,0,0,0-1.3-2.22l-4.63-2.6A2.9,2.9,0,0,0,421.33,48.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,148.22V84a2.86,2.86,0,0,1,1.29-2.24l50.22-29c.71-.41,1.29-.08,1.29.74v64.21a2.89,2.89,0,0,1-1.29,2.24l-50.22,29C377.63,149.38,377.06,149,377.06,148.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.35,149a3,3,0,0,1-2.6,0l-4.63-2.6a2.83,2.83,0,0,1-1.3-2.22V80a2.68,2.68,0,0,1,.41-1.32l7.21,4.11a2.56,2.56,0,0,0-.38,1.27v64.2C377.06,149,377.59,149.41,378.35,149Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.84,53.29c-.1-.65-.63-.88-1.27-.51l-50.22,29a2.66,2.66,0,0,0-.91,1l-7.21-4.11a2.54,2.54,0,0,1,.89-.92l50.22-29a2.88,2.88,0,0,1,2.59,0l4.63,2.59A2.86,2.86,0,0,1,429.84,53.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.82,99.3l-10.4,10.58a1.14,1.14,0,0,0,.19,1.77c.22.14,7.2,4.15,7.2,4.15l10.25-12.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.82,99.3l-10.4,10.58a1.14,1.14,0,0,0,.19,1.77c.22.14,7.2,4.15,7.2,4.15l10.25-12.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,103.47l-10.41,10.58a1.15,1.15,0,0,0,1,1.94l9.43-1.36C378.07,114.63,378.07,103.47,377.06,103.47Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dead-emoji--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395,101a1,1,0,0,1-.69-.28l-7.46-7.18a1,1,0,1,1,1.38-1.44l7.47,7.18a1,1,0,0,1,0,1.42A1,1,0,0,1,395,101Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.54,105.34a1.11,1.11,0,0,1-.43-.09,1,1,0,0,1-.47-1.33l7.46-15.8a1,1,0,0,1,1.33-.48,1,1,0,0,1,.48,1.33l-7.46,15.8A1,1,0,0,1,387.54,105.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.38,87a1,1,0,0,1-.7-.28l-7.46-7.18a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l7.46,7.18a1,1,0,0,1-.69,1.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.91,91.27a1,1,0,0,1-.42-.09,1,1,0,0,1-.48-1.34l7.46-15.79a1,1,0,1,1,1.81.85l-7.46,15.8A1,1,0,0,1,411.91,91.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.21,123.24a1,1,0,0,1-.87-.5,1,1,0,0,1,.37-1.36l32.5-18.77a1,1,0,0,1,1,1.74l-32.5,18.76A1,1,0,0,1,387.21,123.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.86,123.77a3.13,3.13,0,0,1-1.56-.41,4.16,4.16,0,0,1-1.78-3.77v-9.07a1,1,0,1,1,2,0v9.07a2.3,2.3,0,0,0,.78,2,1.83,1.83,0,0,0,1.78-.25,8.34,8.34,0,0,0,3.56-6.48v-9.07a1,1,0,0,1,2,0v9.07a10.26,10.26,0,0,1-4.56,8.21A4.48,4.48,0,0,1,409.86,123.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.58,117.93a1,1,0,0,1-1-1v-8.76a1,1,0,0,1,2,0v8.76A1,1,0,0,1,411.58,117.93Z",
    style: {
      fill: "#455a64"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404Error.1a76997b1583eb7f03a8f79619a9200b.svg";
export { ForwardRef as ReactComponent };